import '@pilot-hub/ui/theme/init'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@pilot-hub/auth'
import App from './App'
import './index.css'
import { ExternPage } from './pages/ExternPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Freigabelink für Externe: eigenständige Seite ohne Login, Layout und Anmelde-Provider
const externToken = window.location.pathname.match(/^\/extern\/([A-Za-z0-9_-]+)\/?$/)?.[1]

ReactDOM.createRoot(document.getElementById('root')!).render(
  externToken ? <React.StrictMode><ExternPage token={externToken} /></React.StrictMode> :
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)